module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Praise for ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Power of Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("“This book is a true gift to the world. It’s insightful and full of calm, helpful wisdom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Richard Carlson, "), _c('br'), _vm._v("author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "apple-conver CharOverride-6"
  }, [_vm._v("D")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("on’t Sweat the Small Stuff")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Many good people, myself included, have problems with impatience and will benefit, as I did, from this lively, insightful book.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Rabbi Harold Kushner, "), _c('br'), _vm._v("author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("When Bad Things Happen to Good People")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“I have been a long-time fan of M.J. Ryan’s books and she continues to outdo herself with her new book, ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The Power of Patience")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". The book is filled with practical, heart-centered nuggets that open the door to experiencing what we all seek, infinite patience.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-5"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Gerald G. Jampolsky, MD, "), _c('br'), _vm._v("author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Shortcuts to God")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“When it comes to patience, we don’t have to change old habits; we can build better ones. M.J. Ryan shows us how.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Sue Bender, author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Plain and")]), _c('span', {
    staticClass: "apple-conver CharOverride-6"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Simple "), _c('br')]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Stretching Lessons:")]), _c('span', {
    staticClass: "apple-conver CharOverride-6"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Daring that Starts from Within")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-6"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Praise for M.J. Ryan’s other work ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Attitudes of Gratitude")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“…an elixir for the soul. M.J. Ryan’s words on gratitude heal the heart and inspire breakthroughs. She helps us to know just how powerful a shift in consciousness can be; we can change our lives by changing our thoughts—what a miracle!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Kathy Freston, "), _c('br'), _vm._v("author of ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Quantum Wellness ")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and "), _c('br')]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The One: Finding Soul Mate Love and Making it Last")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Opened to any page, this book rescues the mind that has forgotten that thanksgiving, independent of circumstances, is the highest wisdom, the most profound liberation, the greatest source of joy")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Sylvia Boorstein, "), _c('br'), _vm._v("author of ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Happiness Is an Inside Job")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“The practice of gratitude empowers, heals, inspires, and fosters heartfelt well-being.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Angeles Arrien, PhD, "), _c('br'), _vm._v("cultural anthropologist and author of "), _c('br')]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Second Half of Life")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Four-Fold Way")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Thank you for this powerful, simple healing. It is a path of joy and clarity.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-10"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Stephen and Ondrea Levine, "), _c('br'), _vm._v("authors of ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Embracing the Beloved")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("A Year to Live")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Trusting Yourself ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“M.J.’s book has softened and yet empowered me with insights, information, and inspiration on the life-enhancing benefits of self-trust.  I wish she had written this while I was raising Wynonna and Ashley. If you’ll take her wisdom to heart you’ll find greater happiness in your relationships and in your mind.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Naomi Judd, "), _c('br'), _vm._v("author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Naomi’s Breakthrough Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“M.J. Ryan is right: many of our individual problems and collective unhappiness stem from our lack of self-trust.")]), _c('span', {
    staticClass: "apple-conver CharOverride-1"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Trusting Yourself")]), _c('span', {
    staticClass: "apple-conver CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("reminds us of this essential aspect of living a full life and offers us stories and practical suggestions for re-establishing self-trust even as we face our human foibles and flaws with honesty and humor. A valuable book for living today to the fullest.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Oriah Mountain Dreamer, "), _c('br'), _vm._v("author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Invitation")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Call")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“With clarity and compassion, M.J. Ryan provided priceless guidance for filling in my self-trust blanks and, better yet, convinced me that I had the ability and wisdom to do so.")]), _c('span', {
    staticClass: "apple-conver CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Trusting Yourself")]), _c('span', {
    staticClass: "apple-conver CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("has shot to the top of my gift-giving list!”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Sue Patton Thoele, "), _c('br'), _vm._v("author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Woman’s Book of Courage")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Cultivating genuine self-trust is at the heart of living and loving fully. In ")]), _c('span', {
    staticClass: "apple-conver CharOverride-7"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("rusting Yourself")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(", M.J. Ryan not only shows us how, she gives us the confidence to take the necessary steps. Through heart-warming stories and insightful guidance, M.J. reminds us of our inherent value, wisdom and wholeness.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-12"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Tara Brach, author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Radical Self-Acceptance")]), _c('span', {
    staticClass: "apple-conver CharOverride-6"
  }), _c('span', {
    staticClass: "CharOverride-5"
  }, [_c('br')]), _c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“M.J. Ryan has identified the great Teacher within us all, that gentle presence, whole and certain, that is always here to guide us. It is no less than the essence of our self. But how do we access it? In engaging personal narrative and precise precept, Ryan takes us by the hand and gently leads us back to ourselves. Perhaps more than any other book,")]), _c('span', {
    staticClass: "apple-conver CharOverride-4"
  }), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Trusting Yourself")]), _c('span', {
    staticClass: "apple-conver CharOverride-7"
  }), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("is an invitation to come home.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Hugh Prather, author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }, [_c('br')]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Little Book of Letting Go")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Notes to Myself")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("365 Health and Happiness Boosters")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Reading ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("365 Health and Happiness Boosters")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" is like lifting my face to the sun each morning. Every little ray of M.J. Ryan’s wisdom warms the heart.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-13"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Sue Patton Thoele, author of eight books, "), _c('br'), _vm._v("including ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Woman’s Book of Courage")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Antidotes to the blues.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Judy Ford, author of ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Wonderful Ways to Love a Child "), _c('br')]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Between Mother and Daughter")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“Happiness is the inherent nature of being human. If you have forgotten the simple truth, this book serves as a wonderful reminder to ‘stop and smell the roses.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Brian Luke Seaward, PhD, "), _c('br'), _vm._v("author of ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Stressed is Desserts Spelled Backward")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("The Giving Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“M.J. Ryan is a wizard at giving. Practical and inspiring, her book offers generosity on every page. ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The Giving Heart")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(" shows us how we can ‘feel the gift in motion’ toward ourselves and others.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Sue Bender, author of")]), _c('span', {
    staticClass: "apple-conver CharOverride-5"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Plain and")]), _c('span', {
    staticClass: "apple-conver CharOverride-6"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Simple "), _c('br')]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Stretching Lessons:")]), _c('span', {
    staticClass: "apple-conver CharOverride-6"
  }), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Daring that Starts from Within")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“This is a wonderful book about the joy, the fulfillment, and, yes, the majesty of giving. Read it and be transformed")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-11"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Daphne Rose Kingma, author of "), _c('br')]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Coming Apart")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Finding True Love")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(", and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The 9 Types of Lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("“M.J. Ryan gives us the ultimate gift—the key to experience the sweetness life offers—in ")]), _c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("The Giving Heart")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v(". This is a book you’ll cherish. You’ll read a little bit, take a deep breath, and feel complete.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-14"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("—Jackie Waldman, author of "), _c('br')]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("The Courage to Give")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" and ")]), _c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Teens with the Courage to Give")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e3f25a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThePowerOfPatience.vue
// module id = 60
// module chunks = 0